import PriceBoostPageView from './price-boost-page-view/index.js';

export default function PriceBoostPage() {
    return <PriceBoostPageView />;
}
